/**
 * Lightweight runtime guard for documents read from Firestore. Confirms the
 * object exists and carries every required key. This is intentionally minimal;
 * a full schema validator (e.g. zod) is planned for the data-access refactor.
 */
export function verifyKeys(obj: unknown, requiredKeys: string[]): boolean {
    if (obj === null || typeof obj !== "object") {
        return false;
    }
    return requiredKeys.every((key) => key in (obj as Record<string, unknown>));
}
